import { requestApi } from '../util/network'

// 获取栏目
export const knowledge =
    () =>
      requestApi(
        '/Knowledge/index',
        'GET',
        {}
      )
// 获取视频列表
export const getKnowledgeList =
(params) =>
requestApi(
    '/Knowledge/getKnowledgeList',
    'POST',
    {...params}
)    
// 获取视频详情
export const getKnowledgeDetail =
(params) =>
requestApi(
    '/Knowledge/getKnowledgeDetail',
    'POST',
    {...params}
)    
// 点赞
export const zanKnowledge =
(params) =>
requestApi(
    '/Knowledge/zanKnowledge',
    'POST',
    {...params}
)    
        